import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {MatSort} from "@angular/material/sort";
import {MatPaginator} from "@angular/material/paginator";
import {UserService} from "../../../services/user.service";
import {OrganizationService} from "../../../services/organization.service";
import {DecisionService} from "../../../services/decision.service";
import {ActivatedRoute, Router} from "@angular/router";
import {MatDialog} from "@angular/material/dialog";
import {MatTableDataSource} from "@angular/material/table";
import {CkmService} from "../../../services/ckm.service";
import {
  ModalAddCkmSimulationComponent
} from "../../../modals/modal-add-ckm-simulation/modal-add-ckm-simulation.component";

@Component({
  selector: 'app-ckm-simulation-list',
  templateUrl: './ckm-simulation-list.component.html',
  styleUrls: ['./ckm-simulation-list.component.scss']
})
export class CkmSimulationListComponent implements OnInit {
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @Input() projectId: any;
  @Input() input_simulations: any;
  constructor(
    public userService: UserService,
    public organizationService: OrganizationService,
    public decisionService: DecisionService,
    public route: ActivatedRoute,
    public router: Router,
    public ckmService: CkmService,
    public dialog: MatDialog,
  ) {
  }

  dataSource: MatTableDataSource<any>;
  columnsToDisplay = ['title', 'created_at', 'created_by_user', 'action'];

  loading = false;
  simulations = [];

  searchModel: any = {
    startDate: undefined,
    endDate: undefined,
    name: ''
  };

  ngOnInit(): void {
    if (this.input_simulations) {
      this.setDataSourceTable(JSON.parse(JSON.stringify(this.input_simulations)));
    } else {
      this.getAllSimulations();
    }
  }

  public getAllSimulations() {
    this.loading = true;
    this.ckmService.getCkmSimulationsList(this.projectId, (result) => {
      this.setDataSourceTable(result);
      this.loading = false;
    }, () => {
      this.loading = false;
    });
  }

  public setDataSourceTable(simulations) {
    this.simulations = simulations;
    this.dataSource = new MatTableDataSource<any>(simulations);
    setTimeout(() => {
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    }, 100);
  }

  public getCreatorFullNameBySurvey(simulation) {
    const userDetails = simulation.created_by_user.details;

    if (userDetails.first_name && userDetails.last_name) {
      return userDetails.first_name + ' ' + userDetails.last_name;
    } else {
      return simulation.created_by_user.email;
    }
  }

  capitalizeFirstLetter(value: string): string {
    return value.charAt(0).toUpperCase() + value.toLowerCase().slice(1);
  }

  applyFilterToDataSource() {
    this.dataSource.data = [...this.simulations];
    if (this.searchModel.name.length > 0) {
      this.dataSource.data = this.dataSource.filteredData.filter((item) => {
        return item.name
          .toLowerCase()
          .includes(this.searchModel.name.toLowerCase());
      });
    }
    if (this.searchModel.startDate) {
      const startDateObj = new Date(this.searchModel.startDate);

      this.dataSource.data = this.dataSource.filteredData.filter((item) => {
        // @ts-ignore
        const createdAt = new Date(item.created_at);
        return createdAt >= startDateObj;
      });
    }

    if (this.searchModel.endDate) {
      const endDateObj = new Date(this.searchModel.endDate);
      this.dataSource.data = this.dataSource.filteredData.filter((item) => {
        // @ts-ignore
        const closedAt = new Date(item?.closed_at);
        return closedAt <= endDateObj;
      });
    }

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  onClickResetFilters() {

    this.searchModel = {
      startDate: undefined,
      endDate: undefined,
      name: ''
    };

    this.dataSource.data = [...this.simulations];
  }

  addNewSimulation() {
    const dialogRef = this.dialog.open(ModalAddCkmSimulationComponent, {
      panelClass: 'fullscreen-dialog',
      data: { projectId: this.projectId }
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }
}
